__turbopack_context__.v({
  "hasNotValueInSelectedLanguage": "flQOPW_hasNotValueInSelectedLanguage",
  "headingLink": "flQOPW_headingLink",
  "tagsList": "flQOPW_tagsList",
  "truncateTo3Lines": "flQOPW_truncateTo3Lines",
});
